import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Mail } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { ActionNode, NodeVisualDefinition } from '../../types';

import { EmailActionConfigType, getEmailPreviewText } from './schema';

/** Typed node for email action */
type EmailActionNodeType = ActionNode<EmailActionConfigType>;

/** Visual definition for the Email Action node */
export const emailActionVisualDefinition: NodeVisualDefinition = {
  key: 'EmailAction',
  label: 'Email',
  description: 'Send an email to one or more recipients',
  icon: Mail,
  color: 'teal',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getEmailPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Email Action nodes on the canvas.
 */
export const EmailActionNode = React.memo<NodeProps<EmailActionNodeType>>(
  (props) => (
    <BaseNode
      {...props}
      definition={emailActionVisualDefinition}
      className="@EmailActionNode"
    />
  ),
);

EmailActionNode.displayName = 'EmailActionNode';
